module.exports = __webpack_public_path__ + "img/report_hysd.4808da95.png";